import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@mdi/react';
import { Button } from "../../../Buttons";
import { Divider } from "../../../Divider";
var style = {
  fontWeight: 500,
  display: 'flex',
  justifyContent: 'space-between'
};
export var SelectAllButton = function SelectAllButton(_ref) {
  var selectAll = _ref.selectAll,
      allSelected = _ref.allSelected,
      selectPromptMessage = _ref.selectPromptMessage,
      _ref$customAction = _ref.customAction,
      customAction = _ref$customAction === void 0 ? {} : _ref$customAction;
  var buttonLabel = customAction.buttonLabel,
      handleClick = customAction.handleClick,
      buttonIcon = customAction.buttonIcon,
      buttonVariant = customAction.buttonVariant,
      buttonColor = customAction.buttonColor;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem, {
    style: style,
    component: "div",
    onClick: selectAll
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: allSelected,
    value: "checkedA",
    onChange: selectAll
  }), selectPromptMessage), /*#__PURE__*/React.createElement("div", {
    id: "customAction"
  }, buttonLabel && /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    variant: buttonVariant || 'contained',
    color: buttonColor || 'primary'
  }, buttonIcon && /*#__PURE__*/React.createElement(Icon, {
    path: buttonIcon,
    size: 1,
    color: "white"
  }), buttonLabel))), /*#__PURE__*/React.createElement(Divider, {
    variant: "solid"
  }));
};